import { CalendarOutlined } from '@ant-design/icons'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Space, Tag, Typography } from 'antd'
import dayjs from 'dayjs'
import { FC, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { Event as EventModel } from '../../models/Event'
import { useAppSelector } from '../../store/hooks'
import { selectEventParticipationsByIds } from '../../store/membership/EventParticipationReducer'
import { selectEventById } from '../../store/membership/EventReducer'
import ParticipationStatus from '../participationStatus/ParticipationStatus'

const { Text } = Typography
type Props = SBModelComponent<EventModel> & {}

const CardWithMemberParticipation: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectEventById(id!))
  const participations = useAppSelector(
    selectEventParticipationsByIds(item?.participations ?? [])
  )

  if (!item || !participations) {
    return <></>
  }

  const memberParticipation = useCallback(
    () => participations.find((p) => !p.firstName),
    [participations]
  )

  /**
   * The number of guests is equal to the number of particicapation for the member - 1
   */
  const guestsCount = participations.length - 1

  return (
    <Link to={`/membership/events/${item.id}/informations`}>
      <Space orientation="vertical" size={0}>
        <Text style={{ fontWeight: 'bold' }} className="m-0">
          {item.en.title}
        </Text>
        <Space>
          <Tag icon={<CalendarOutlined />}>
            {dayjs(item.start).format('DD/MM/YY')} -{' '}
            {dayjs(item.end).format('DD/MM/YY')}
          </Tag>
          <ParticipationStatus.Tag id={memberParticipation()?.status} />
          <Tag color="purple">{guestsCount} guest(s)</Tag>
        </Space>
      </Space>
    </Link>
  )
}

type CardWithMemberParticipationType = {
  CardWithMemberParticipation: typeof CardWithMemberParticipation
}

export { CardWithMemberParticipation, type CardWithMemberParticipationType }
